export default "__VITE_ASSET__CVeur2lc__";